<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <router-link class="decoration" to="/tinternalcourses/scheduled">Scheduled Internal Courses</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Update {{ schedule.schedule_code || '' }}
      </h6>
      <div class="container-fluid mt-2">
        <div class="d-flex justify-content-end mb-1">
          <button type="button" class="btn btn-sm btn-outline-primary bdr-rad font-size_def" @click="goBack">
            Back to Internal Scheduled Courses
          </button>
        </div>

        <div class="card custom_bdr_rds shadow p-2">
          <div class="card-body custom_bdr_rds">
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>
            <form v-if="!isLoading" @submit.prevent="updateSchedule">
              <div class="row">
                <div class="col-md-3 form-group">
                  <label class="custom-label text-dark">Course Category</label>
                  <select v-model="form.category" class="form-control form-control-sm bdr-rad" @change="categoryChanged">
                    <option value="">Select</option>
                    <option v-for="category in categories" :key="category" :value="category">{{ category }}</option>
                  </select>
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-label text-dark">Course <span class="required-mark">*</span></label>
                  <select v-model="form.course_id" class="form-control form-control-sm bdr-rad" required @change="courseChanged">
                    <option value="">Select...</option>
                    <option v-for="course in filteredCourses" :key="course.id" :value="course.id">{{ course.course_title }}</option>
                  </select>
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-label text-dark">Module</label>
                  <select v-model="form.module_id" class="form-control form-control-sm bdr-rad">
                    <option value="">Select...</option>
                    <option v-for="module in modules" :key="module.id" :value="module.id">{{ module.module_name }}</option>
                  </select>
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-label text-dark">Trainer <span class="required-mark">*</span></label>
                  <select v-model="form.trainer" class="form-control form-control-sm bdr-rad" required>
                    <option value="">Select...</option>
                    <option v-for="trainer in trainers" :key="trainer.tt_trainer_id || trainer.id" :value="trainerLabel(trainer)">{{ trainerLabel(trainer) }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 form-group">
                  <label class="custom-label text-dark">Available Slots <span class="required-mark">*</span></label>
                  <input v-model.number="form.available_slots" type="number" min="0" class="form-control form-control-sm bdr-rad" required>
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-label text-dark">Class Date <span class="required-mark">*</span></label>
                  <input v-model="form.class_date" type="date" class="form-control form-control-sm bdr-rad" required>
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-label text-dark">Start Time <span class="required-mark">*</span></label>
                  <input v-model="form.start_time" type="time" class="form-control form-control-sm bdr-rad" required>
                </div>
                <div class="col-md-3 form-group">
                  <label class="custom-label text-dark">End Time <span class="required-mark">*</span></label>
                  <input v-model="form.end_time" type="time" class="form-control form-control-sm bdr-rad" required>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-2">
                <button type="submit" class="btn btn-sm btn-outline-primary bdr-rad" :disabled="isSaving">
                  {{ isSaving ? 'Updating...' : 'Update' }}
                </button>
              </div>
            </form>
            <div v-else class="d-flex justify-content-center py-4"><div class="spinner-border text-primary"></div></div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(), isLoading: true, isSaving: false,
      errorMessage: '', successMessage: '', schedule: {}, categories: [], courses: [], trainers: [],
      form: { category: '', course_id: '', module_id: '', trainer: '', available_slots: 0, class_date: '', start_time: '', end_time: '' },
    };
  },
  computed: {
    filteredCourses() { return this.courses.filter((course) => !this.form.category || course.training_category === this.form.category); },
    selectedCourse() { return this.courses.find((course) => Number(course.id) === Number(this.form.course_id)) || null; },
    modules() { return (this.selectedCourse && this.selectedCourse.modules) || []; },
  },
  mounted() { this.loadPage(); },
  methods: {
    async loadPage() {
      this.isLoading = true;
      try {
        const headers = { Authorization: 'Bearer ' + this.token };
        const [scheduleResponse, dashboardResponse, trainerResponse] = await Promise.all([
          axios.get('/ticourses/schedule-view?id=' + this.$route.query.id, { headers }),
          axios.get('/ticourses/dashboard', { headers }),
          axios.get('/training/index', { headers }),
        ]);
        const dashboard = dashboardResponse.data || {};
        this.schedule = scheduleResponse.data.schedule || {};
        this.categories = dashboard.categories || [];
        this.courses = dashboard.courses || [];
        this.trainers = (trainerResponse.data && trainerResponse.data.all_data) || [];
        this.form = {
          category: this.schedule.course_category || '',
          course_id: this.schedule.course_id || '',
          module_id: this.schedule.module_id || '',
          trainer: this.schedule.trainer || '',
          available_slots: Number(this.schedule.available_slots || 0),
          class_date: this.schedule.class_date || '',
          start_time: this.formatTime(this.schedule.start_time),
          end_time: this.formatTime(this.schedule.end_time),
        };
      } catch (error) {
        this.errorMessage = (error.response && error.response.data && (error.response.data.message || error.response.data.name)) || 'Unable to load scheduled course.';
      } finally { this.isLoading = false; }
    },
    trainerLabel(trainer) { return trainer.tt_trainer_id ? trainer.tt_trainer_id + ' - ' + trainer.tt_trainer_name : (trainer.label || trainer.name || trainer.trainer_name || ''); },
    formatTime(value) { return value ? String(value).slice(0, 5) : ''; },
    categoryChanged() { if (!this.filteredCourses.some((course) => Number(course.id) === Number(this.form.course_id))) { this.form.course_id = ''; this.form.module_id = ''; } },
    courseChanged() { const course = this.selectedCourse; if (course) { this.form.available_slots = Number(course.allocated_seats || 0); if (!this.modules.some((module) => Number(module.id) === Number(this.form.module_id))) this.form.module_id = this.modules.length ? this.modules[0].id : ''; } },
    goBack() { this.$router.push('/tinternalcourses/scheduled'); },
    async updateSchedule() {
      this.isSaving = true; this.errorMessage = ''; this.successMessage = '';
      try {
        const schedule = { course_id: this.form.course_id, available_slots: this.form.available_slots, rows: [{ module_id: this.form.module_id, trainer: this.form.trainer, class_date: this.form.class_date, start_time: this.form.start_time, end_time: this.form.end_time }] };
        await axios.post('/ticourses/update-schedule?id=' + this.$route.query.id, { schedule }, { headers: { Authorization: 'Bearer ' + this.token } });
        this.successMessage = 'Scheduled course updated successfully.';
        setTimeout(() => this.goBack(), 500);
      } catch (error) { this.errorMessage = (error.response && error.response.data && (error.response.data.message || error.response.data.name)) || 'Unable to update scheduled course.'; } finally { this.isSaving = false; }
    },
  },
};
</script>
